class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	// Erst ergänzende Produkte (Search & Discovery), sonst ähnliche — Mitkauf statt „mehr vom Gleichen“
	// (Marketing-Plan 01.10.2026: Goufrais-Käufer sahen hier nur Goufrais).
	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			const base = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`;
			this.loadRecommendations(`${base}&intent=complementary`)
				.then(found => found || this.loadRecommendations(base))
				.catch(e=>{
					console.warn(e);
				})
		}
	}

	loadRecommendations(url){
		return fetch(url)
			.then(response => response.text())
			.then(text => {
				const innerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-recommendations-performed]');
        if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
        	this.innerHTML = innerHTML.innerHTML;
        	return true;
        }
        return false;
			})
	}
}
customElements.define('cart-recommendations', CartRecommendations);